import { Badge } from '@/components/ui/badge';

const colorMap = {
  SuperAdmin: 'bg-green-100 text-green-800 border-green-200',
  PowerUser: 'bg-blue-100 text-blue-800 border-blue-200',
  User: 'bg-gray-100 text-gray-800 border-gray-200',
};

const RoleBadge = ({ role }) => {
  const colorClasses = colorMap[role] || 'bg-gray-100 text-gray-800 border-gray-200';

  return (
    <Badge variant="outline" className={colorClasses}>
      {role}
    </Badge>
  );
};

export default RoleBadge;
